<div class="d-flex flex-row">
    <div class="filter-item shadow py-2 text-center" [ngClass]="{'filter-item-selected': isItemSelected(item), 'ml-3': !first}"
        *ngFor="let item of items; let first = first" (click)="onSelectItem(item)">
        <div class="font-weight-bold">{{item.name | playerStatus}}</div>
    </div>
</div>